import { FaCode, FaUsers, FaLightbulb, FaHeart } from 'react-icons/fa';

export const techCategories = [
    'frontend',
    'backend',
    'cloud',
    'devops',
    'database',
    'ai'
];

export const highlights = [
    {
        icon: <FaCode size={24} />,
        title: "20 Years Experience",
        description: "Building scalable web applications and cloud-native solutions"
    },
    {
        icon: <FaUsers size={24} />,
        title: "Team Player",
        description: "Mentoring teammates and improving processes"
    },
    {
        icon: <FaLightbulb size={24} />,
        title: "Problem Solver",
        description: "From legacy modernization to greenfield projects"
    },
    {
        icon: <FaHeart size={24} />,
        title: "Passionate Builder",
        description: "Creating software that's stable, scalable, and enjoyable"
    }
];

export const experiences = [
    {
        period: "2025 - Present",
        title: "Senior Software Engineer",
        company: "MGT Insurance (Acquired Oregon Mutual operationally in 2025)",
        bullets: [
            "Led design and development of migration workflows and tooling to support transition of nearly 4,000 insurance policies from Oregon Mutual systems to MGT platforms",
            "Architected scalable migration processes designed to support future carrier onboarding and repeatable migration operations",
            "Accelerated development workflows, troubleshooting, migration, and implementation by utilizing AI-assisted development tools and methodologies including Claude, ChatGPT, and Amazon Q",
        ]
    },
    {
        period: "2018 - 2025",
        title: "Associate -> Senior Software Engineer",
        company: "Oregon Mutual",
        bullets: [
            "Led design and delivery of custom software solutions, owning projects end-to-end",
            "Architected AWS serverless solutions & CI/CD pipelines",
            "Modernized legacy systems and mentored engineers",
            "Collaborated with data engineers to design scalable DynamoDB data models and backend services",
        ]
    },
    {
        period: "2007 - 2018",
        title: "Programmer/Analyst -> Web Application Admin/Developer",
        company: "Linfield College",
        bullets: [
            "Built custom C#/ASP.NET and PHP/MySQL apps supporting institutional operations",
            "Improved site security & migrated legacy Java systems",
            "Deployed address validation software reducing returned mail",
            "Developed custom reports, data entry screens, and import/export processes in Colleague ERP system",
        ]
    },
    {
        period: "2005 - 2007",
        title: "PC Support Technician ->Network Administrator",
        company: "Evergreen Aviation",
        bullets: [
            "Provided technical support for 300+ users globally",
            "Managed AD/Exchange and created automation scripts",
            "Designed and developed an internal application to manage and track IT loaner laptops",
        ]
    }
];